import { useNavigate, useSearch } from "@tanstack/react-router";
import { TaskModal } from "./TaskModal";

export function TaskModalRouter() {
    const search = useSearch({ from: "/_hub/$customerId/dashboard" });
    const navigate = useNavigate();

    const close = () => {
        void navigate({
            to: ".",
            search: (prev) => ({ ...prev, task: undefined, edit: undefined }),
        });
    };

    if (search.task === undefined) {
        return null;
    }

    if (search.task === "new") {
        return <TaskModal mode="create" onClose={close} />;
    }

    if (search.edit === 1) {
        return <TaskModal mode="edit" taskId={search.task} onClose={close} />;
    }

    return <TaskModal mode="view" taskId={search.task} onClose={close} />;
}
